import React from 'react';

function ButtonList(props) {
    const { btnList } = props;
    return (
        <div>
            {
                btnList.map((btn) => {
                    return <button
                        key={btn?.key || btn?.name}
                        type={btn?.type || "button"}
                        className={`btn ${btn?.classNames}`}
                        disabled={btn?.disabled}
                        onClick={btn?.onClick || null}
                        style={btn?.style || null}
                    >
                        {btn?.name}
                    </button>
                })
            }
        </div >
    )
}

export default ButtonList